module.exports = "/* You can add global styles to this file, and also import other style files */\n.btn-popup-tarif {\n  display: block;\n  width: 100%; }\n.btn-popup-tarif .btn {\n    display: block;\n    width: 100%; }\n.btn-popup-tarif .btn.btn-go-tarif {\n      background: #f87744;\n      color: #fff; }\n.btn-popup-tarif .btn.btn-go-tarif:hover {\n        background: #dd7045; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main